<div class="filter-page-container">
  <div class="filter-page-header">
    <mat-icon>{{ activeFilters() ? 'check_circle_outline' : 'filter_list' }}</mat-icon>
    <span [style.color]="activeFilters() ? 'gray' : 'black'" class="title">{{ 'main.filters' | translate }}</span>
  </div>

  <div class="content">
    <div class="nav">

      @if (page() !== 'budget') {
        <div class="nav-item bottom-border" aria-label="all" (click)="choose('all')">
          <a class="nav-link" matRipple>
            <span class="title all-data">{{ ('main.all_' + page()) | translate }}</span>
          </a>
        </div>
      }

      @if (vm().countries?.length) {
        <div class="nav-item bottom-border" aria-label="countries">
          <button type="button"
                  class="filter-title"
                  (click)="showCountry.set(!showCountry())"
                  [attr.aria-expanded]="showCountry()"
                  [attr.aria-controls]="'countries-panel'">
            {{ 'organization.country' | translate }}
            <mat-icon class="expand-icon">{{ showCountry() ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>

          <mat-radio-group id="countries-panel" [value]="countryModel()"
                           class="radio-group"
                           [class.visible]="showCountry()"
                           [class.hidden]="!showCountry()">
            @for (c of vm().countries; track c.id) {
              <mat-radio-button class="radio-buttons"
                                [value]="c.id"
                                [checked]="c.selected"
                                (change)="choose({ country: c.id }); countryModel.set(c.id)">
                {{ c.name }}
              </mat-radio-button>
            }
          </mat-radio-group>
        </div>
      }

      @if (vm().cantons?.length) {
        <div class="nav-item bottom-border" aria-label="cantons">
          <button type="button"
                  class="filter-title"
                  (click)="showCanton.set(!showCanton())"
                  [attr.aria-expanded]="showCanton()"
                  [attr.aria-controls]="'cantons-panel'">
            {{ 'main.canton' | translate }}
            <mat-icon class="expand-icon">{{ showCanton() ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          <mat-selection-list id="cantons-panel"
                              [class.visible]="showCanton()"
                              [class.hidden]="!showCanton()"
                              (selectionChange)="chooseCanton($event)">
            @for (cant of vm().cantons; track cant.id) {
              <mat-list-option class="target-list"
                               [value]="cant.id"
                               [selected]="cant.selected"
                               [matTooltip]="cant.name">
                {{ cant.name }}
              </mat-list-option>
            }
          </mat-selection-list>
        </div>
      }

      @if (vm().organizations?.length) {
        <div class="nav-item bottom-border" aria-label="organizations">
          <button type="button"
                  class="filter-title"
                  (click)="showOrganization.set(!showOrganization())"
                  [attr.aria-expanded]="showOrganization()"
                  [attr.aria-controls]="'orgs-panel'">
            {{ 'user.organization' | translate }}
            <mat-icon class="expand-icon">{{ showOrganization() ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          <mat-selection-list id="orgs-panel"
                              [class.visible]="showOrganization()"
                              [class.hidden]="!showOrganization()"
                              (selectionChange)="chooseOrg($event)">
            @for (org of vm().organizations; track org.id) {
              <mat-list-option class="target-list"
                               [value]="org.id"
                               [selected]="org.selected"
                               [matTooltip]="org.name">
                {{ org.name }}
              </mat-list-option>
            }
          </mat-selection-list>
        </div>
      }

      @if (vm().platforms?.length) {
        <div class="nav-item bottom-border" aria-label="platforms">
          <div class="filter-title">{{ 'main.platforms' | translate }}
            <span class="clean" (click)="choose({ platforms: '' }); platformsModel.set(null)">{{ 'clean' | translate }}</span>
          </div>
          <mat-radio-group class="radio-group" [value]="platformsModel()">
            @for (plt of vm().platforms; track plt.id) {
              <mat-radio-button class="radio-buttons"
                                (change)="choose({ platforms: plt.id }); platformsModel.set(plt.id)"
                                [value]="+plt.id"
                                [checked]="plt?.selected"
                                [matTooltip]="plt.title">
                {{ plt.title }}
              </mat-radio-button>
            }
          </mat-radio-group>
        </div>
      }

      @if (vm().eventRegistration !== undefined) {
        <div class="nav-item-checkbox bottom-border alone" aria-label="eventRegistration"
        matTooltip="{{'event.event_registration' | translate}}">
          <span class="title">{{ 'event.event_registration' | translate }}</span>
          <mat-checkbox [checked]="eventRegistrationModel()"
                        (change)="choose({eventRegistration: true, selected: $event.checked});
                         eventRegistrationModel.set($event.checked)"
                        [labelPosition]="'before'">
          </mat-checkbox>
        </div>
      }

      @if (vm().publicEvents !== undefined) {
        <div class="nav-item bottom-border">
          <div class="filter-title">{{ 'event.events_visibility' | translate }}
            <span class="clean" (click)="choose({ publicEvents: '' }); publicEventsModel.set(null)">
              {{ 'clean' | translate }}</span>
          </div>
          <mat-radio-group class="radio-group" [value]="publicEventsModel()"
                                   (change)="choose({ publicEvents: $event.value }); publicEventsModel.set($event.value)">
            <mat-radio-button class="radio-buttons" value="public">
              {{ 'event.public' | translate }}</mat-radio-button>
            <mat-radio-button class="radio-buttons" value="internal">
              {{ 'event.internal' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      }

      @if (vm().eventTypes?.length) {
        <div class="nav-item bottom-border" aria-label="event-types">
          <button type="button" class="filter-title" (click)="showEventType.set(!showEventType())"
                  [attr.aria-expanded]="showEventType()" [attr.aria-controls]="'eventtypes-panel'">
            {{ 'event.eventType' | translate }}
            <mat-icon class="expand-icon">{{ showEventType() ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          <mat-selection-list id="eventtypes-panel" #eventTypeList
                              [class.visible]="showEventType()"
                              [class.hidden]="!showEventType()"
                              (selectionChange)="chooseEventType($event)">
            @for (gr of vm().eventTypes; track gr.id) {
              <mat-list-option class="target-list"
                               [value]="gr.id"
                               [selected]="eventTypeModel().includes(gr.id)"
                               [matTooltip]="gr.name">
                <span style="width: 10%" [style.background-color]="gr?.color">&nbsp;&nbsp;&nbsp;</span>&nbsp;{{ gr.name }}
              </mat-list-option>
            }
          </mat-selection-list>
        </div>
      }

      @if (vm().targetGroups?.length) {
        <div class="nav-item bottom-border" aria-label="target-groups">
          <button type="button" class="filter-title" (click)="showTargetGroup.set(!showTargetGroup())"
                  [attr.aria-expanded]="showTargetGroup()" [attr.aria-controls]="'tgs-panel'">
            {{ 'event.target_group' | translate }}
            <mat-icon class="expand-icon">{{ showTargetGroup() ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          <mat-selection-list id="tgs-panel" #targetGroupsList
                              [class.visible]="showTargetGroup()"
                              [class.hidden]="!showTargetGroup()"
                              (selectionChange)="chooseTG($event)">
            @for (gr of vm().targetGroups; track gr.id) {
              <mat-list-option class="target-list"
                               [value]="gr.id"
                               [selected]="targetGroupsModel().includes(gr.id)"
                               [matTooltip]="(gr?.targetNumber != null ? ('0' + gr.targetNumber).slice(-2) : '') + ' - ' + (gr?.ageMask || '')">
                {{ (gr?.targetNumber != null ? ('0' + gr.targetNumber).slice(-2) : '') + ' - ' + (gr?.ageMask || '') }}
              </mat-list-option>
            }
          </mat-selection-list>
        </div>
      }

      @if (vm().mileStoneEvent !== undefined) {
        <div class="nav-item-checkbox bottom-border alone" aria-label="eventRegistration"
        matTooltip="{{'event.mile_stone_event' | translate}}">
          <span class="title">{{ 'event.mile_stone_event' | translate }}</span>
          <mat-checkbox [checked]="mileStoneEventModel()"
                        (change)="choose({mileStoneEvent: true, selected: $event.checked});
                         mileStoneEventModel.set($event.checked)"
                        [labelPosition]="'before'">
          </mat-checkbox>
        </div>
      }

      @if (vm().myEvents !== undefined) {
        <div class="nav-item-checkbox bottom-border alone" aria-label="eventRegistration"
        matTooltip="{{'event.myEvents' | translate}}">
          <span class="title">{{ 'event.myEvents' | translate }}</span>
          <mat-checkbox [checked]="myEventsModel()"
                        (change)="choose({myEvents: true, selected: $event.checked});
                         myEventsModel.set($event.checked)"
                        [labelPosition]="'before'">
          </mat-checkbox>
        </div>
      }

      @if (vm().tags?.length) {
        <div class="nav-item bottom-border" aria-label="tags">
          <button type="button"
                  class="filter-title"
                  (click)="showTag.set(!showTag())"
                  [attr.aria-expanded]="showTag()"
                  [attr.aria-controls]="'tags-panel'">
            {{ 'main.tag' | translate }}
            <mat-icon class="expand-icon">{{ showTag() ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          <mat-selection-list id="tags-panel"
                              [class.visible]="showTag()"
                              [class.hidden]="!showTag()"
                              (selectionChange)="chooseTags($event)">
            @for (tag of vm().tags; track tag.id) {
              <mat-list-option class="target-list"
                               [value]="tag.id"
                               [selected]="tag.selected"
                               [matTooltip]="tag.name">
                {{ tag.name }}
              </mat-list-option>
            }
          </mat-selection-list>
        </div>
      }

      @if (vm().parishOrganizations?.length) {
        <div class="nav-item bottom-border" aria-label="parishOrganizations">
          <button type="button"
                  class="filter-title"
                  (click)="showParishOrganizations.set(!showParishOrganizations())"
                  [attr.aria-expanded]="showParishOrganizations()"
                  [attr.aria-controls]="'parishOrganizations-panel'">
            {{ 'parishOrganization.title' | translate }}
            <mat-icon class="expand-icon">{{ showParishOrganizations() ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          <mat-selection-list id="parishOrganizations-panel"
                              [class.visible]="showParishOrganizations()"
                              [class.hidden]="!showParishOrganizations()"
                              (selectionChange)="chooseParishOrganizations($event)">
            @for (parishOrganization of vm().parishOrganizations; track parishOrganization.id) {
              <mat-list-option class="target-list"
                               [value]="parishOrganization.id"
                               [selected]="parishOrganization.selected"
                               [matTooltip]="parishOrganization.name">
                {{ parishOrganization.name }}
              </mat-list-option>
            }
          </mat-selection-list>
        </div>
      }

      @if (vm().activities?.length) {
        <div class="nav-item bottom-border" aria-label="activities">
          <button type="button"
                  class="filter-title"
                  (click)="showActivities.set(!showActivities())"
                  [attr.aria-expanded]="showActivities()"
                  [attr.aria-controls]="'activities-panel'">
            {{ 'parishOrganization.activity' | translate }}
            <mat-icon class="expand-icon">{{ showActivities() ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          <mat-selection-list id="activities-panel"
                              [class.visible]="showActivities()"
                              [class.hidden]="!showActivities()"
                              (selectionChange)="chooseActivities($event)">
            @for (activity of vm().activities; track activity.id) {
              <mat-list-option class="target-list"
                               [value]="activity.id"
                               [selected]="activity.selected"
                               [matTooltip]="activity.name">
                {{ activity.name }}
              </mat-list-option>
            }
          </mat-selection-list>
        </div>
      }

      @if (vm().roles?.length) {
        <div class="nav-item bottom-border" aria-label="roles">
          <button type="button"
                  class="filter-title"
                  (click)="showRole.set(!showRole())"
                  [attr.aria-expanded]="showRole()"
                  [attr.aria-controls]="'roles-panel'">
            {{ 'user.role' | translate }}
            <mat-icon class="expand-icon">{{ showRole() ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          <mat-selection-list id="roles-panel"
                              [class.visible]="showRole()"
                              [class.hidden]="!showRole()"
                              (selectionChange)="chooseRole($event)">
            @for (role of vm().roles; track role.id) {
              <mat-list-option class="target-list"
                               [value]="role.id"
                               [selected]="role.selected"
                               [matTooltip]="('main._' + role?.name) | translate">
                {{ ('main._' + role?.name) | translate }}
              </mat-list-option>
            }
          </mat-selection-list>
        </div>
      }

      @if (vm().activated !== undefined) {
        <div class="nav-item bottom-border alone" aria-label="activated">
          <span class="title">{{ 'user.activated' | translate }}</span>
          <mat-checkbox [checked]="vm().activated"
                        (change)="choose({ activated: $event.checked })"
                        [labelPosition]="'before'">
          </mat-checkbox>
        </div>
      }

      @if (vm().recommendator !== undefined) {
        <div class="nav-item bottom-border alone" aria-label="recommendator">
          <span class="title">{{ 'user.recommendator' | translate }}</span>
          <mat-checkbox [checked]="vm().recommendator"
                        (change)="choose({ recommendator: $event.checked })"
                        [labelPosition]="'before'">
          </mat-checkbox>
        </div>
      }

      @if (vm().noActivated !== undefined) {
        <div class="nav-item bottom-border alone" aria-label="noActivated">
          <span class="title">{{ 'user.noActivated' | translate }}</span>
          <mat-checkbox [checked]="vm().noActivated"
                        (change)="choose({ noActivated: $event.checked })"
                        [labelPosition]="'before'">
          </mat-checkbox>
        </div>
      }

      @if (vm().cantonFB?.length) {
        <div class="nav-item bottom-border" aria-label="cantons-fb">
          <button type="button"
                  class="filter-title"
                  (click)="showCantonFB.set(!showCantonFB())"
                  [attr.aria-expanded]="showCantonFB()"
                  [attr.aria-controls]="'cantons-fb-panel'">
            {{ 'main.canton' | translate }}
            <mat-icon class="expand-icon">{{ showCantonFB() ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          <mat-radio-group id="cantons-fb-panel" class="radio-group"
                           [class.visible]="showCantonFB()"
                           [class.hidden]="!showCantonFB()">
            @for (canton of vm().cantonFB; track canton.id) {
              <mat-radio-button class="radio-buttons"
                                (change)="choose({ cantonFB: canton.id })"
                                [value]="canton.id"
                                [checked]="canton.selected">
                {{ canton.name }}
              </mat-radio-button>
            }
          </mat-radio-group>
        </div>
      }

      @if (vm().organizationsFB?.length) {
        <div class="nav-item bottom-border" aria-label="organizations-fb">
          <button type="button"
                  class="filter-title"
                  (click)="showOrganizationFB.set(!showOrganizationFB())"
                  [attr.aria-expanded]="showOrganizationFB()"
                  [attr.aria-controls]="'orgs-fb-panel'">
            {{ 'user.organization' | translate }}
            <mat-icon class="expand-icon">{{ showOrganizationFB() ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          <mat-radio-group id="orgs-fb-panel" class="radio-group"
                           [class.visible]="showOrganizationFB()"
                           [class.hidden]="!showOrganizationFB()">
            @for (org of vm().organizationsFB; track org.id) {
              <mat-radio-button class="radio-buttons"
                                (change)="choose({ organizationsFB: org.id })"
                                [value]="org.id"
                                [checked]="org.selected"
                                [matTooltip]="org.name">
                {{ org.name }}
              </mat-radio-button>
            }
          </mat-radio-group>
        </div>
      }

      @if (vm().blogTypes?.length) {
        <div class="nav-item bottom-border" aria-label="blog-types">
          <button type="button" class="filter-title" (click)="showTag.set(!showTag())"
                  [attr.aria-expanded]="showTag()" [attr.aria-controls]="'blogtypes-panel'">
            {{ 'main.blogType' | translate }}
            <mat-icon class="expand-icon">{{ showTag() ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          <mat-selection-list id="blogtypes-panel" [class.visible]="showTag()" [class.hidden]="!showTag()">
            @for (bt of vm().blogTypes; track bt.id) {
              <mat-list-option class="target-list"
                               [matTooltip]="bt.name"
                               [selected]="bt.selected"
                               (click)="choose({ tag: bt.id, selected: !bt.selected })">
                {{ bt.name }}
              </mat-list-option>
            }
          </mat-selection-list>
        </div>
      }

      @if (vm().blobVisibility) {
        <div class="nav-item bottom-border" aria-label="blogs-visibility">
          <div class="filter-title">{{ 'blog.blogs_visibility' | translate }}</div>
          <mat-radio-group class="radio-group" [value]="publicBlogsModel()">
            <mat-radio-button class="radio-buttons" (change)="choose({ publicBlogs: 'public' })" [value]="'public'">
              {{ 'event.public' | translate }}
            </mat-radio-button>
            <mat-radio-button class="radio-buttons" (change)="choose({ publicBlogs: 'internal' })" [value]="'internal'">
              {{ 'event.internal' | translate }}
            </mat-radio-button>
            <mat-radio-button class="radio-buttons" (change)="choose({ publicEvents: '' })" [value]="'any'">
              {{ 'event.any' | translate }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      }

      @if (vm().learningPathsVisibility) {
        <div class="nav-item bottom-border" aria-label="learning-paths-visibility">
          <div class="filter-title">{{ 'learning_paths.visibility' | translate }}
            <span class="clean" (click)="choose({ learningPathsVisibility: '' }); learningPathsVisibilityModel.set('')">{{ 'clean' | translate }}</span>
          </div>
          <mat-radio-group class="radio-group" [value]="learningPathsVisibilityModel()">
            <mat-radio-button class="radio-buttons" (change)="choose({ learningPathsVisibility: 'public' })" [value]="'public'">
              {{ 'event.public' | translate }}
            </mat-radio-button>
            <mat-radio-button class="radio-buttons" (change)="choose({ learningPathsVisibility: 'internal' })" [value]="'internal'">
              {{ 'event.internal' | translate }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      }

      @if (vm().marketplaceCategories?.length) {
        <div class="nav-item bottom-border" aria-label="marketplace-categories">
          <button type="button" class="filter-title" (click)="showMarketplaceCategories.set(!showMarketplaceCategories())"
                  [attr.aria-expanded]="showMarketplaceCategories()" [attr.aria-controls]="'marketplace-categories-panel'">
            {{ 'marketplaces.marketplace_category' | translate }}
            <mat-icon class="expand-icon">{{ showMarketplaceCategories() ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          <mat-selection-list id="marketplace-categories-panel" [class.visible]="showMarketplaceCategories()" [class.hidden]="!showMarketplaceCategories()" (selectionChange)="chooseMarketplaceCategory($event)">
            @for (gr of vm().marketplaceCategories; track gr.id) {
              <mat-list-option class="marketplace-category-list"
                               [value]="gr.id"
                               [selected]="gr.selected"
                               [matTooltip]="!gr.total ? gr.name : !gr.notActivated ? gr.name + ' (' + gr.total + ')' : gr.name + ' (' + gr.total + ') ' + gr.notActivated">
                {{ gr.name }}
                @if (gr.total) { ({{ gr.total }})
                  @if (gr.notActivated) { <div class="red">{{ gr.notActivated }}</div> }
                }
              </mat-list-option>
              @for (subgr of gr.marketplaceSubcategory; track subgr) {
                <mat-list-option class="marketplace-subcategory-list"
                                 [value]="subgr.id + '_sub'"
                                 [selected]="subgr.selected"
                                 [matTooltip]="!subgr.total ? subgr.name : !subgr.notActivated ? subgr.name + ' (' + subgr.total + ')' : subgr.name + ' (' + subgr.total + ') ' + subgr.notActivated">
                  &nbsp;&nbsp;&nbsp;{{ subgr.name }}
                  @if (subgr.total) { ({{ subgr.total }})
                    @if (subgr.notActivated) { <div class="red">{{ subgr.notActivated }}</div> }
                  }
                </mat-list-option>
              }
            }
          </mat-selection-list>
        </div>
      }

      @if (vm().marketplaceType) {
        <div class="nav-item bottom-border" aria-label="marketplace-type">
          <div class="filter-title">{{ 'marketplaces.type' | translate }}
            <span class="clean" (click)="choose({ marketplaceType: '' }); marketplaceType.set('')">{{ 'clean' | translate }}</span>
          </div>
          <mat-radio-group class="radio-group" [value]="marketplaceType()">
            <mat-radio-button class="radio-buttons" (change)="choose({ marketplaceType: 'search' })" [value]="'search'">
              {{ 'marketplaces.i_search' | translate }}
            </mat-radio-button>
            <mat-radio-button class="radio-buttons" (change)="choose({ marketplaceType: 'offer' })" [value]="'offer'">
              {{ 'marketplaces.i_offer' | translate }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      }

      @if (vm().hasEvent) {
          <div class="nav-item bottom-border" aria-label="marketplace-type">
            <div class="filter-title">{{ 'hubOverview.event_filter' | translate }}
              <span class="clean" (click)="choose({ hasEvent: '' }); hasEvent.set('')">{{ 'clean' | translate }}</span>
            </div>
            <mat-radio-group class="radio-group" [value]="hasEvent()"
            (change)="hasEvent.set($event.value); choose({ hasEvent: $event.value })">
              <mat-radio-button class="radio-buttons" [value]="'true'">
                {{ 'hubOverview.has_event' | translate }}
              </mat-radio-button>
              <mat-radio-button class="radio-buttons" [value]="'false'">
                {{ 'hubOverview.has_no_event' | translate }}
              </mat-radio-button>
            </mat-radio-group>
          </div>
        }

      @if (vm().hasLearnPath) {
          <div class="nav-item bottom-border" aria-label="marketplace-type">
            <div class="filter-title">{{ 'hubOverview.learnPath_filter' | translate }}
              <span class="clean" (click)="choose({ hasLearnPath: '' }); hasLearnPath.set('')">{{ 'clean' | translate }}</span>
            </div>
            <mat-radio-group class="radio-group" [value]="hasLearnPath()"
            (change)="hasLearnPath.set($event.value); choose({ hasLearnPath: $event.value })">
              <mat-radio-button class="radio-buttons" [value]="'true'">
                {{ 'hubOverview.has_learnPath' | translate }}
              </mat-radio-button>
              <mat-radio-button class="radio-buttons" [value]="'false'">
                {{ 'hubOverview.has_no_learnPath' | translate }}
              </mat-radio-button>
            </mat-radio-group>
          </div>
      }

      @if (vm().marketplaceStatus) {
        <div class="nav-item bottom-border" aria-label="marketplace-status">
          <div class="filter-title">{{ 'marketplaces.status' | translate }}
            <span class="clean" (click)="choose({ marketplaceStatus: '' }); marketplaceStatus.set('')">{{ 'clean' | translate }}</span>
          </div>
          <mat-radio-group class="radio-group" [value]="marketplaceStatus()">
            <mat-radio-button class="radio-buttons" (change)="choose({ marketplaceStatus: 'activated' })" [value]="'activated'">
              {{ 'marketplaces.activated' | translate }}
            </mat-radio-button>
            <mat-radio-button class="radio-buttons" (change)="choose({ marketplaceStatus: 'notActivated' })" [value]="'notActivated'">
              {{ 'marketplaces.notActivated' | translate }}
            </mat-radio-button>
            <mat-radio-button class="radio-buttons" (change)="choose({ marketplaceStatus: 'blocked' })" [value]="'blocked'">
              {{ 'marketplaces.blocked' | translate }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      }

    </div>
  </div>
</div>

